export const alertColor = {
    success: 'success',
    info: 'info',
    warning: 'warning',
    error: 'error',
};
